export enum Radius {
    default = "5px",
}
